import React from 'react';
import { useIntl } from 'react-intl';
import { Dropdown } from 'rsuite';
import { useSettingsStore } from '../../stores/SettingsStore';

interface ButtonImportDropdownMeetingProps {
  setTypeMeeting: (typeMeeting: 'schedule' | 'visit' | 'report' | 'schedule-visit') => void;
  setShowModalInsertImportExcel: (show: boolean) => void;
  source: string;
}

const ButtonImportDropdownMeeting = ({
  setTypeMeeting,
  source,
  setShowModalInsertImportExcel,
}: ButtonImportDropdownMeetingProps) => {
  const intl = useIntl();
  const { settings } = useSettingsStore();

  const renderButton = (props: any, ref: any) => (
    <button {...props} ref={ref} className="btn btn-light-success mt-3">
      <i className="fas fa-file-download fs-2 me-2"></i>{' '}
      {intl.formatMessage({ id: 'FORM.LABEL.IMPORT_EXCEL' })}
    </button>
  );

  const getDropdownItems = (): React.ReactNode[] => {
    const actions: React.ReactNode[] = [];
    const mode = settings.feature_meeting_mode || '';

    if (mode.includes('1')) {
      actions.push(
        <Dropdown.Item key="report" onClick={() => {
          setTypeMeeting('report');
          setShowModalInsertImportExcel(true);
        }}>
          {intl.formatMessage({ id: 'MEETING.ACTION.FINISHED' })}
        </Dropdown.Item>
      );
    }

    if (mode.includes('2')) {
      actions.push(
        <Dropdown.Item key="schedule" onClick={() => {
          setTypeMeeting('schedule');
          setShowModalInsertImportExcel(true);
        }}>
          {intl.formatMessage({ id: 'MEETING.ACTION.SCHEDULED' })}
        </Dropdown.Item>
      );
    }

    // Visit di-comment, tidak dipakai:
    // if (mode.includes('3')) {
    //   actions.push(
    //     <Dropdown.Item key="visit" onClick={() => {
    //       setTypeMeeting('visit');
    //       setShowModalInsertImportExcel(true);
    //     }}>
    //       {intl.formatMessage({ id: 'MEETING.ACTION.VISIT' })}
    //     </Dropdown.Item>
    //   );
    // }

    if (mode.includes('4')) {
      actions.push(
        <Dropdown.Item key="schedule-visit" onClick={() => {
          setTypeMeeting('schedule-visit');
          setShowModalInsertImportExcel(true);
        }}>
          {intl.formatMessage({ id: 'FORM.LABEL.VISIT_SCHEDULE' })}
        </Dropdown.Item>
      );
    }

    // Fallback: jika tidak ada yang cocok, tampilkan default
    if (actions.length === 0) {
      actions.push(
        <Dropdown.Item key="schedule" onClick={() => {
          setTypeMeeting('schedule');
          setShowModalInsertImportExcel(true);
        }}>
          {intl.formatMessage({ id: 'MEETING.ACTION.SCHEDULED' })}
        </Dropdown.Item>,
        <Dropdown.Item key="report" onClick={() => {
          setTypeMeeting('report');
          setShowModalInsertImportExcel(true);
        }}>
          {intl.formatMessage({ id: 'MEETING.ACTION.FINISHED' })}
        </Dropdown.Item>,
        <Dropdown.Item key="schedule-visit" onClick={() => {
          setTypeMeeting('schedule-visit');
          setShowModalInsertImportExcel(true);
        }}>
          {intl.formatMessage({ id: 'FORM.LABEL.VISIT_SCHEDULE' })}
        </Dropdown.Item>
      );
    }

    return actions;
  };

  return (
    <Dropdown renderToggle={renderButton} noCaret placement="bottomEnd">
      {getDropdownItems()}
    </Dropdown>
  );
};

export default ButtonImportDropdownMeeting;
